// extracted by mini-css-extract-plugin
module.exports = {"footer":"_footer_footer__tFwYU","footerCol":"_footer_footerCol__35Z3b","languageContainerMobile":"_footer_languageContainerMobile__kL_wC"};